const Backbone = require('backbone');
const Marionette = require('backbone.marionette');
const templates = require('../templates');
const HeaderView = require('./header.js');
const MainView = require('./main.js');
const FooterView = require('./footer.js');
const PopupFooterView = require('./popup_footer.js');
const time = require('../data/time.js');
const controller = require('../controllers/terminal.js');
const app = require('../app.js');
const moment = require('moment');

module.exports = Marionette.LayoutView.extend({
  template: templates.layout,
  initialize() {
    this.listenTo(app.vent, 'openFooterPopup', controller.openFooterPopup);
    this.listenTo(app.vent, 'closeFooterPopup', controller.closeFooterPopup);
    this.listenTo(app.vent, 'openActivityPopup', controller.openActivityPopup);
    this.listenTo(app.vent, 'closeActivityPopup', controller.closeActivityPopup);
    this.listenTo(app.vent, 'displayPrevWeekAnim', controller.displayPrevWeekAnim);
    this.listenTo(app.vent, 'displayNextWeekAnim', controller.displayNextWeekAnim);
    this.listenTo(app.vent, 'displayChangeWeek', controller.displayChangeWeek);
    this.listenTo(app.vent, 'displayFastLoading', controller.displayFastLoading);
    this.listenTo(app.vent, 'displayFooterActually', controller.displayFooterActually);
    this.listenTo(app.vent, 'displayFooterNext', controller.displayFooterNext);
    this.listenTo(app.vent, 'scrollToCurrentBlock', controller.scrollToCurrentBlock);
    this.listenTo(app.vent, 'animateOverflowBookings', controller.animateOverflowBookings);
  },
  regions: {
    header: 'header',
    main: 'main',
    footer: 'footer',
    popup_footer: '.popup_footer'
  },
  onBeforeShow() {
    const club = this.model.get('club');
    const currentBookings = club.get('bookings').extend();
    const studios = this.model.get('studios');
    const studioIds = this.model.get('studioIds');

    currentBookings.fetch({
      data: {
        startDay: moment(time.get('currentDate')).format('YYYY-MM-DD'),
        endDay: moment(time.get('currentDate'))
          .add(1, 'day')
          .format('YYYY-MM-DD'),
        studioId: studioIds || null
      }
    });

    const filters = club.get('activitygroups');

    this.showChildView(
      'header',
      new HeaderView({
        model: new Backbone.Model({
          club,
          date: time,
          filters: controller.getFiltersToDisplay(filters),
          studios
        })
      })
    );

    const boundBookings = controller.getWeekBookings(club.get('bookings').extend(), time, studioIds);
    const filteredBookings = controller.getFilteredBookings(boundBookings, filters);

    this.showChildView(
      'main',
      new MainView({
        collection: controller.getSections(filteredBookings)
      })
    );

    this.showChildView(
      'footer',
      new FooterView({
        model: new Backbone.Model({
          currentBookings: controller.getCoursesCollection(currentBookings, time, false, 0, 2),
          nextBookings: controller.getCoursesCollection(currentBookings, time, true, 0, 2)
        })
      })
    );

    // extra regions
    this.showChildView(
      'popup_footer',
      new PopupFooterView({
        model: new Backbone.Model({
          actually: controller.getCoursesCollection(currentBookings, time, false, 0, 2),
          next: controller.getCoursesCollection(currentBookings, time, true, 0, 2)
        })
      })
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/terminal.js